<template>
  <span class="ra" :class="{ 'ra--img': src }" :style="{ width: size + 'px', height: size + 'px' }" aria-hidden="true">
    <img v-if="src" :src="src" alt="" loading="lazy" @error="broken = true" />
    <span v-else class="ra__initials" :style="{ fontSize: Math.round(size * 0.38) + 'px' }">{{ initials }}</span>
  </span>
</template>

<script>
/**
 * Avatar chico en el listado (contactos, productos): su imagen o, si no tiene, las
 * iniciales, como el de la ficha (ItemProfile).
 */
import { nameInitials } from "@/utils/nameInitials";
import { recordImage } from "@/utils/recordImageStore";

export default {
  name: "RecordAvatar",
  props: {
    item: { type: Object, required: true },
    modelName: { type: String, required: true },
    size: { type: Number, default: 28 },
  },
  data() {
    return { broken: false };
  },
  computed: {
    src() {
      if (this.broken || !this.item._id) return null;
      return recordImage(this.modelName, this.item._id, this.item.updatedAt);
    },
    initials() {
      return nameInitials(this.item.name);
    },
  },
  watch: {
    src() {
      this.broken = false;
    },
  },
};
</script>

<style scoped>
.ra {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.45rem;
  border: 1px solid var(--bs-border-color);
  background-color: var(--bs-tertiary-bg);
  color: var(--bs-primary);
  font-weight: 700;
  letter-spacing: 0.02em;
  overflow: hidden;
  text-decoration: none;
}
/* Imagen entera sobre blanco, como en la ficha. */
.ra--img {
  background-color: #fff;
  padding: 2px;
}
.ra img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
#darkdesign .ra {
  border-color: var(--dark-border-color);
  background-color: var(--dark-bg-tertiary);
}
#darkdesign .ra--img {
  background-color: #fff;
}
</style>
